import * as Yup from 'yup'
import { FormValues } from '../models/form'
import { ATTACHMENT_EXTRAFIELD } from '../models/post'

type ValidationRules = any

const checkOnlyLetters = (value: string | undefined) => {
  const digitOrSymbolRegex = /\d|\W/g
  const words = value?.split(' ') || []
  return words.every((word) => !digitOrSymbolRegex.test(word))
}

const validateNotificationTimes = (value: any) => {
  return value && (!value[0].interval && !value[1].interval) ? false : true
}

const phoneRegExp = new RegExp(
  /^\+?((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
);

const rules: ValidationRules = {
  user: {
    name: Yup.string()
      .min(3, 'Please enter a first name between 3 and 255 characters')
      .max(255, 'Please enter a first name between 3 and 255 characters')
      .test('onlyLetters', 'Field should not contain numbers and special symbols', checkOnlyLetters)
      .required('First Name is required'),
    last_name: Yup.string()
      .min(3, 'Please enter a last name between 3 and 255 characters')
      .max(255, 'Please enter a last name between 3 and 255 characters')
      .test('onlyLetters', 'Field should not contain numbers and special symbols', checkOnlyLetters)
      .required('Last Name is required'),
    password: Yup.string()
      .min(8, 'Please enter a password between 8 and 255 characters')
      .max(255, 'Please enter a password between 8 and 255 characters')
      .required('Password is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    password_confirmation: Yup.string()
      .oneOf([Yup.ref('password'), null], "Passwords doesn't match")
      .required('Password confirmation is required'),
    phone_number: Yup.string().required('Phone Number is required')
      .matches(phoneRegExp, "Phone number is not valid"),
    company: Yup.string().required('Company Name is required'),
  },
  agency: {
    name: Yup.string()
      .min(3, 'Please enter an company name between 3 and 255 characters')
      .max(255, 'Please enter an company name between 3 and 255 characters')
      .required('Company name is required')
  },
  project: {
    name: Yup.string()
      .min(3, 'Please enter a project name between 3 and 255 characters')
      .max(255, 'Please enter a project name between 3 and 255 characters')
      .required('Project name is required'),
    timezone: Yup.string().required('Timezone is required')
  },
  invite_members: {
    invite_to_agency: Yup.array().of(
      Yup.object().shape({
        name: Yup.string()
          .min(3, 'Please enter a name between 3 and 255 characters')
          .max(255, 'Please enter a name between 3 and 255 characters')
          .test('onlyLetters', 'Field should not contain numbers and special symbols', checkOnlyLetters)
          .required('Name is required'),
        email: Yup.string().email('Invalid email').required('Email is required'),
        agency_role: Yup.string().required('Role is required')
      })
    ),
    invite_to_project: Yup.array().of(
      Yup.object().shape({
        name: Yup.string()
          .min(3, 'Please enter a name between 3 and 255 characters')
          .max(255, 'Please enter a name between 3 and 255 characters')
          .test('onlyLetters', 'Field should not contain numbers and special symbols', checkOnlyLetters)
          .required('Name is required'),
        email: Yup.string().email('Invalid email').required('Email is required'),
        project_role: Yup.string().required('Role is required')
      })
    ),
    members: Yup.array().required(' ')
  },
  label: {
    text: Yup.string()
      .min(3, 'Please enter a label text between 3 and 255 characters')
      .max(255, 'Please enter a label text between 3 and 255 characters')
      .required('Label is required'),
    color: Yup.string().required('Label is required')
  },
  link: {
    [ATTACHMENT_EXTRAFIELD.LINK]: Yup.string()
      .url('Please enter a valid url adress')
      .required('Link is required'),
    [ATTACHMENT_EXTRAFIELD.NAME]: Yup.string()
      .min(3, 'Please enter a name between 3 and 255 characters')
      .max(255, 'Please enter a name between 3 and 255 characters'),
    [ATTACHMENT_EXTRAFIELD.DESCRIPTION]: Yup.string()
      .min(3, 'Please enter a description between 3 and 255 characters')
      .max(255, 'Please enter a description between 3 and 255 characters')
  },
  time: {
    hours: Yup.number().required().positive().integer().min(1, '').max(12, ''),
    minutes: Yup.number().required().positive().integer().min(0, '').max(59, '')
  },
  post: {
    content: Yup.string(),
    hashtag: Yup.string()
  },
  card:{
    cardName: Yup.string().required('Card Name is required').min(3,'Incorrect fields. Try again.').max(255,'Incorrect fields. Try again.'),
    cardNumber: Yup.string().required('Card Number is required').matches(/^[0-9 ]+$/, "Must be only digits").test('len', 'Invalid card number', val => Number(val?.length) <= 19),
    expiryMonth: Yup.number().required('Month is required'),
    expiryYear: Yup.number().required('Year is required'),
    cvc:Yup.string().required('CVC is required').matches(/^[0-9]+$/, "Must be only digits").test('len', 'Invalid CVC', val => Number(val?.length) >= 3)
  },
  billing_address:{
    firstName: Yup.string().required('First Name is a required field') .min(3, 'Please enter a first name between 3 and 255 characters')
              .max(255, 'Please enter a first name text between 3 and 255 characters'),
    lastName:Yup.string().required('Last Name is a required field') .min(3, 'Please enter a last name between 3 and 255 characters')
            .max(255, 'Please enter a last name between 3 and 255 characters'),
    address: Yup.string().required('Address is a required field') .min(3, 'Please enter a address between 3 and 255 characters')
            .max(255, 'Please enter a address between 3 and 255 characters'),
    state: Yup.string().required('State is a required field') .min(3, 'Please enter a state between 3 and 255 characters')
          .max(255, 'Please enter a state between 3 and 255 characters'),
    city: Yup.string().required() .min(3, 'Please enter a city between 3 and 255 characters')
          .max(255, 'Please enter a city between 3 and 255 characters'),
    country:Yup.string().required() .min(3, 'Please enter a city between 3 and 255 characters')
          .max(255, 'Please enter a city between 3 and 255 characters'),
    zip:Yup.string().required() .min(3, 'Please enter a city between 3 and 255 characters')
          .max(255, 'Please enter a city between 3 and 255 characters'),
  },
  notification_settings: {
    notify_timeframe: Yup.array().of(
      Yup.object().shape({
        scheduled_times: Yup.array()
        .when('isChecked', {
          is: (value:any) =>{ 
             return !!value
           },
          then: Yup.array().test('interval', 'required',validateNotificationTimes ),
          otherwise: Yup.array().nullable()
        })
      })
    )
  },
  hashtag:{
    pool_name: Yup.string().required('Pool Name is a required field'),
    hashtags:Yup.string().required('Hashtag is a required field')
  }
}

const createScheme = (values: FormValues, entity: string) => {
  const fields: any = {}

  for (let field of Object.keys(values)) {
    fields[field] = rules[entity][field]
  }

  return Yup.object().shape(fields)
}

export default createScheme
